// extracted by mini-css-extract-plugin
export default {"ctaContainer":"ExploreAuthors_ctaContainer__1WxES","textContent":"ExploreAuthors_textContent__ENYat","ctaButton":"ExploreAuthors_ctaButton__DpngZ"};